import { render, staticRenderFns } from "./compStage.vue?vue&type=template&id=6a703432&"
import script from "./compStage.vue?vue&type=script&lang=js&"
export * from "./compStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a703432')) {
      api.createRecord('6a703432', component.options)
    } else {
      api.reload('6a703432', component.options)
    }
    module.hot.accept("./compStage.vue?vue&type=template&id=6a703432&", function () {
      api.rerender('6a703432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameLog/components/compStage.vue"
export default component.exports